// Genomsnittlig skatt per anställd
export const MUNICIPALITY_SCHABLON = 311495;

// Genomsnittlig skattesats
export const AVERAGE_TAX = 0.40344;

export const VALFARDSTJANSTER = {
  forskoleplats: 'forskoleplats',
  grundskola: 'grundskola',
  gymnasielarare: 'gymnasielarare',
  polis: 'polis',
  sjukskoterska: 'sjukskoterska',
  specialistlakare: 'specialistlakare',
  underskoterskaIHemtjanst: 'underskoterskaIHemtjanst',
};

export const AVTRYCK_PER_VALFARDSTJANSTER = {
  [VALFARDSTJANSTER.forskoleplats]: 181800,
  [VALFARDSTJANSTER.grundskola]: 32562312,
  [VALFARDSTJANSTER.gymnasielarare]: 652895,
  [VALFARDSTJANSTER.polis]: 643432,
  [VALFARDSTJANSTER.sjukskoterska]: 676550,
  [VALFARDSTJANSTER.specialistlakare]: 1454031,
  [VALFARDSTJANSTER.underskoterskaIHemtjanst]: 503076,
};

export const VALFARDSTJANSTER_NAMES = {
  [VALFARDSTJANSTER.forskoleplats]: {
    singular: 'förskoleplats',
    plural: 'förskoleplatser',
  },
  [VALFARDSTJANSTER.grundskola]: {
    singular: 'grundskola',
    plural: 'grundskolor',
  },
  [VALFARDSTJANSTER.gymnasielarare]: {
    singular: 'gymnasielärare',
    plural: 'gymnasielärare',
  },
  [VALFARDSTJANSTER.polis]: {
    singular: 'polis',
    plural: 'poliser',
  },
  [VALFARDSTJANSTER.sjukskoterska]: {
    singular: 'sjuksköterska',
    plural: 'sjuksköterskor',
  },
  [VALFARDSTJANSTER.specialistlakare]: {
    singular: 'specialistläkare',
    plural: 'specialistläkare',
  },
  [VALFARDSTJANSTER.underskoterskaIHemtjanst]: {
    singular: 'undersköterska i hemtjänsten',
    plural: 'undersköterskor i hemtjänsten',
  },
};

export const getSkatteintakter = (lonekostnaderPerAr, bolagsskattPerAr, totalSkatt) => {
  return totalSkatt
    ? parseInt(totalSkatt, 10)
    : parseInt(lonekostnaderPerAr, 10) * AVERAGE_TAX + parseInt(bolagsskattPerAr, 10);
};

export const calcAntalValfardtjanst = (lonekostnaderPerAr, bolagsskattPerAr, valfardstjanst, totalSkatt) => {
  let totalCost;
  if (totalSkatt && totalSkatt !== 'undefined') {
    totalCost = parseInt(totalSkatt, 10);
  } else {
    totalCost = parseInt(lonekostnaderPerAr, 10) * AVERAGE_TAX + parseInt(bolagsskattPerAr, 10);
  }
  return Math.round(totalCost / AVTRYCK_PER_VALFARDSTJANSTER[valfardstjanst]);
};

export const calcNrOfValfardtjanst = (nrOfEmployed, valfardstjanst) => {
  return Math.round((nrOfEmployed * MUNICIPALITY_SCHABLON) / AVTRYCK_PER_VALFARDSTJANSTER[valfardstjanst]);
};

export const calcKey = ({ companyName, antalAnstallda, salt }) => {
  return (companyName.length + parseInt(antalAnstallda, 10) + salt).toString();
};

export const tempusify = (nr, valfardstjanst) => {
  return nr === 1
    ? VALFARDSTJANSTER_NAMES[valfardstjanst].singular
    : VALFARDSTJANSTER_NAMES[valfardstjanst].plural;
};
